import React from 'react';
import { VscQuestion } from 'react-icons/vsc';

import * as S from './styles';

interface QuestionBoxProps {
	text: string;
	width?: number;
}

export default function QuestionBox({ text, width = 3 }: QuestionBoxProps) {
	return (
		<S.container width={width} title={text}>
			<VscQuestion />
		</S.container>
	);
}
